module.exports = __webpack_public_path__ + "img/usa-stomach-cancer-male.53ac5064.png";